<template>
  <div class="pawn-shop-owner slide">
    <HorizontalAnimation :animation="animation" :loop="true" />
    <div class="horizontal-layout animated fadeIn delay-2s">
      <p class="store">API &amp; Law Enforcement</p>
      <h1>Pawn Shop Owner</h1>
      <p>O’Toole introduces an undercover officer to the pawn shop owner for a future controlled sale. After a few more successful sales, LE organizes a bust to take down the fence operation.</p>
    </div>
    <router-link to="/conclusion-video">
      <NextButton />
    </router-link>
  </div>
</template>

<script>
import HorizontalAnimation from '@/components/HorizontalAnimation.vue'
import NextButton from '@/components/NextButton.vue'
import PawnShopOwner from '@/assets/pawn-shop-owner.js'

export default {
  name: 'pawn-shop-owner',
  components: {
    HorizontalAnimation,
    NextButton
  },
  data() {
    return {
      animation: PawnShopOwner
    }
  },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss" scoped>
  .horizontal-layout {
    margin-top: 30px;
  }
</style>
